import c from 'classnames';
import React, { useContext } from 'react';
import { MobileContext } from '../../../Context';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { isDeviationTransparent } from '../../_helpers';
import s from './CommissionCover.scss';
var getCoverImageAttributes = function (deviation) {
    var coverUrl = DeviationMediaService.getLargestFullview(deviation).src;
    return {
        backgroundImage: "url('" + coverUrl + "')",
    };
};
export var CommissionCover = function (_a) {
    var deviation = _a.deviation;
    var isMobile = useContext(MobileContext);
    if (isMobile || !deviation.coverImage) {
        return null;
    }
    var isCoverTransparent = isDeviationTransparent(deviation.coverImage);
    var coverImageStyle = getCoverImageAttributes(deviation.coverImage);
    return (React.createElement("div", { className: c(s['cover-image'], isCoverTransparent && s['no-shadow']), style: coverImageStyle }));
};
CommissionCover.displayName = 'CommissionCover';
export default CommissionCover;
//# sourceMappingURL=CommissionCover.js.map